import { useTranslation } from "react-i18next";

const HERO_IMAGE =
  "https://readdy.ai/api/search-image?query=A%20bright%20airy%20wide%20shot%20of%20neatly%20arranged%20colorful%20streetwear%20items%20including%20pastel%20sneakers%2C%20a%20folded%20mint%20hoodie%2C%20a%20cream%20t-shirt%20and%20a%20sage%20cap%20with%20generous%20negative%20space%20on%20a%20soft%20warm%20neutral%20background%2C%20soft%20natural%20daylight%2C%20fresh%20minimal%20editorial%20fashion%20photography%2C%20modern%20Western%20aesthetic%2C%20gentle%20pastel%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=1600&height=900&seq=usfans-home-hero&orientation=landscape&nocache=true";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex min-h-[620px] w-full items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/70 to-background-50/90" />

      <div className="relative z-10 mx-auto w-full max-w-[900px] px-4 py-20 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-100/80 px-4 py-1.5 text-xs font-semibold text-primary-800">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-sparkling-2-line"></i>
          </span>
          {t("hero.badge")}
        </span>

        <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
          {t("hero.title")}
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          {t("hero.subtitle")}
        </p>

        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#categories"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            {t("hero.ctaPrimary")}
            <i className="ri-arrow-down-line"></i>
          </a>
          <a
            href="#guides"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-900 transition-colors hover:bg-background-100 sm:w-auto"
          >
            {t("hero.ctaSecondary")}
            <i className="ri-arrow-down-line"></i>
          </a>
        </div>

        <p className="mt-6 text-sm text-foreground-600">{t("hero.note")}</p>
      </div>
    </section>
  );
}